export const colors = {
    primary: "#202020",
    secondary: "#f0ae51",
    background: "#F2F2F2",
    dark: "#000",
    gray: "#808080",
    orange: "#ffa500",
    delete: "#E44B48", // error borders, error text
    border: "#E9E9E9", //passcode bg
    button: "#2F4D8B", // button bg, passcode border
    title: "#414141",
    box: "#FDFDFD",
    light: "#fff", // container bg, light text
    selection: "#2F4D8B",
    dot: "#6FDC8C",
    shadow: "#9B9B9B",
    selected: "#E0EBFF",
    transparent: "transparent",
    error: "#E44B48", // unused
    disabledText: "rgba(0, 0, 0, 0.26)",
    disabledBg: "#ddd",
    disclaimer: "#6a6a6a",
    scheduled: "green",
    decline: "red",
    errorBox: "#FFCCCB",
    warningBox: "rgb(255, 243, 195)",
    warning: "#FFA000",
    green: "#2F6113",
    greenLight: "#A6DF6F",
    yellow: "#FFCC00",
    yellowLight: "#FFFF66",
    red: "#E44B48",
    redLight: "#F9DEDC",
    dialogBackground: "rgba(0,0,0,0.3)",
    grey: "#EDEDED",
    greyLight: "#F9F9F9",
    path: "#E8ECEF",
    snackBarTitle: "#541313",
    snackBarText: "#313033",
    snackBarBackground: "#FBEAEA",
    infoBox: "#E6F3FA",
    infoIcon: "#0288D1",
    noticeIcon: "#ED6C02",
    noticeText: "#5F2B01",
    noticeBox: "#FDF0E6",
    infoText: "#013654",
    badgeBackground: "#D5F0B1",
    badgeText: "#254211",
    absentText: "#750E13",
    absentBackground: "#FFD7D9",
    tardyText: "#70491C",
    tardyBackground: "#FAF6CF",
    excusedTardyText: "#002D9C",
    excusedTardyBackground: "#D0E2FF",
    excusedAbsentText: "#002D9C",
    excusedAbsentBackground: "#D0E2FF",
    jobBorder: "#CAC5CD",
    snackBarSuccessBackground: "#322F35",
    seniorityBadgeBackground: "#F2F5F7",
    expiredBadgeBackground: "#ffd7d9",
    expiredBadgeText: "#750E13",
    shiftCalendarButtonBorder: "#79747E",
    shiftCalendarText: "#49454F",
    shiftCalendarArrow: "#1C1B1F",
    fieldText: "#1C1B1F",
    appBackground: "#F2F2F2",
    fieldBackground: "#F8F8F8",
    activeFieldBorder: "#2F4D8B",
    inactiveFieldBorder: "#49454F",
    approvedRequestBackground: "#A7F0BA",
    approvedRequestText: "#044317",
    expiredRequestBackground: "#F2F5F7",
    expiredRequestText: "#1C2B36",
    rejectedRequestBackground: "#FFD7D9",
    rejectedRequestText: "#750E13",
    headerBackground: "#141218",
    spotsLeftBadgeBackground: "#E8DAFF",
    spotsLeftBadgeText: "#491D8B",
    flexiBadgeBackground: "rgba(242, 245, 247, 1)",
    flexiBadgeText: "rgba(28, 43, 54, 1)",
    partialBadgeBackground: "rgba(242, 245, 247, 1)",
    partialBadgeText: "rgba(28, 43, 54, 1)",
    spotTextSmall: "rgba(0, 0, 0, 0.6)",
    bottomBorderColor: "#CAC4D0",
    backgroundLight: "#EEE",
    urgentBackground: "#FFF8E1",
    urgentBorder: "#FFE082",
    urgentBadgeBackground: "#FFF3CD",
    urgentBadgeText: "#856404",
    // A value the server has not set yet, drawn as a slot waiting to be filled
    // rather than as an absence. pendingText on pendingBackground is 6.3:1.
    pendingBorder: "#C2C7D0",
    pendingBackground: "#F5F6F8",
    pendingText: "#5A5F66",
    // The connector between the two legs of one journey.
    railLine: "#DCE2EC",
};
